import { useState } from "react";
import Papa from "papaparse";
import PrimaryButton from "../../helperComponents/PrimaryButton";
import { serverLine } from "../../../controllers/network/serverLine";
import LoadingSection from "../../helperComponents/LoadingSection";
import styled from "styled-components";
import CustomLabel from "../../customUiForCs/CustomLabel";
import CustomLabelLarge from "../../customUiForCs/CustomLabelLarge";

const Container = styled.div`
  padding: 20px;
  background-color: var(--surface);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid var(--borderDim);
`;

export default function CSVUploaderForMigration({
  collectionName,
  path,
  title,
  message,
}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        console.log("Parsed Data:", results.data);
        setData(results.data);
      },
      error: (err) => {
        console.error("Parsing Error:", err);
      },
    });
  };

  if (loading) return <LoadingSection />;

  return (
    <Container>
      <CustomLabelLarge>{title}</CustomLabelLarge>
      <CustomLabel>{message}</CustomLabel>

      <br />
      <input type="file" accept=".csv" onChange={handleFileChange} />
      <pre>{JSON.stringify(data, null, 2)}</pre>

      <PrimaryButton onClick={upload}>Upload</PrimaryButton>
    </Container>
  );

  async function upload() {
    setLoading(true);
    await serverLine.post(path, { collectionName, rows: data });
    setLoading(false);
  }
}
